import React, {useState, useEffect, useReducer} from 'react';

import SideControls from '../components/layout/SideNav';
import {Row, SubHeadingRow} from '../components/layout/Misc';
import { Accordion, Icon, Sidebar} from 'semantic-ui-react'
import { Cell } from 'react-foundation';
import styled from 'styled-components';
import moment from 'moment';
import Map from '../components/TheMap';
import RightSideControl from 'components/RightSideBar';

import MapLayerConfigSection from 'components/map-explorer/AccordionSection';
import ResponsiveContainer from 'components/layout/PageComponents';


import MapTopography from 'components/map/MapTopography';
import MapShapefile from 'components/map/MapShapefile';
import MapRasters from 'components/map/MapRasters';
import MapOpenStreetMap from 'components/map/MapOpenStreetMap';


import LayerConfig, {
  floodHazards,
  ExtentForecast,
  GloFasForecast,
  Epochs,
  AdministrationAreas,
  MapPageConfig,
} from '../config/layer-config';


const InvisibleAccordion = styled(Accordion)`
    background: none;
`;

const SecondLevelAccordion = styled.div`
  padding-left: 15px;
`;

const MapContainer = styled.div`
  margin-right: 90px;
  margin-left: 65px;
  height: calc(100vh - 101px); //bit weird but we need to make sure the map takes the entire available screen for the side bars
`

const AccordionSection = props => {
  return (
  <React.Fragment>
    <Accordion.Title
      active={props.activeAccordion === props.title}
      index={props.title}
      level={props.level}
      onClick={props.handleAccordionClick}
    >
      <SubHeadingRow>
        <Cell large={1}><Icon name="dropdown"/></Cell>
        <Cell large={11}>{props.title}</Cell>
      </SubHeadingRow>
    </Accordion.Title>
    <Accordion.Content active={props.activeAccordion === props.title}>
      {props.children}
    </Accordion.Content>
  </React.Fragment>
  )
};


const DataExplorer = (props) => {

  const initialState = {}

  MapPageConfig.forEach(section => {
    const sectionState = {}
    section.components.forEach(component => {
      sectionState[component.stateProperty] = component.initialState || false
    })
    initialState[section.section] = sectionState
  })

  const [mapOptions, setAllMapOptions] = useState(initialState)
  const [_, forceUpdate] = useReducer(x => x + 1, 0);
  const [key, setKey] = useState(0)


  const [accordionActiveIndex, setAccordionActiveIndex] = useState({
    level1: 0,
    level2: 0
  });
  const [controlsVisible, setControlsVisible] = useState(true);

  const setMapOptions = (props) => {
    setAllMapOptions(Object.assign({}, mapOptions, props));
    console.log("State was changed though")
  }
    const shapeFilesShowing = [];
    const rasterFilesShowing = [];
    const topographyLayersShowing = [];

    MapPageConfig.forEach(sectionConfig => {

      const sectionState = mapOptions[sectionConfig.section]

      sectionConfig.components.forEach(componentConfig => {

        // if the state for the component is set to something
        if (sectionState[componentConfig.stateProperty]) {

          if (componentConfig.layerType == 'shapefile') {
            shapeFilesShowing.push(componentConfig.shapeFileConfig)
          }
          else if (componentConfig.layerType == 'topography') {
            console.log(componentConfig)
            topographyLayersShowing.push(componentConfig.layerConfig)
          }
          else if (componentConfig.layerType == 'rasterfile') {
            rasterFilesShowing.push(componentConfig.layerConfig)
          }
          else if (componentConfig.layerType === 'select-shapefile') {
            const layerShowing = sectionState[componentConfig.stateProperty]
            if (layerShowing) {
              const shapeFile = componentConfig.shapefiles.find(shapefile => shapefile.name === layerShowing)
              console.log("pushing: ", shapeFile, layerShowing)
              console.log(componentConfig.shapefiles)
              shapeFilesShowing.push(shapeFile)
            }
          }
          else if (componentConfig.layerType === 'select-rasterfile') {
            const layerShowing = sectionState[componentConfig.stateProperty]

            if (layerShowing) {
              const rasterFile = componentConfig.rasterfiles.find(raster => raster.name === layerShowing)
              if (rasterFile === undefined) {
                console.log("No raster file in component config matching name: ", layerShowing)
                console.log(componentConfig.rasterfiles)
              } 
              console.log("Pushing: ", rasterFile)
              rasterFilesShowing.push(rasterFile)
            } else {
              console.log("layer not showing", componentConfig.stateProperty)
            }
            console.log(rasterFilesShowing)
          }

          else if (componentConfig.layerType == 'multi-shapefile') {
            sectionState[componentConfig.stateProperty].forEach(layerShowing => {
              const shapeFile = componentConfig.shapefiles.find(shapefile => shapefile.name === layerShowing)
              shapeFilesShowing.push(shapeFile)
            })
          }
        }

      })
    })



    const handleAccordionClick = (e, titleProps) => {
        const { index } = titleProps;
        const level = titleProps.level || 'level1';
        const newIndex = (accordionActiveIndex[level] == index) ? -1 : index;
        const newState = {};
        newState['level1'] = accordionActiveIndex.level1
        newState[level] = newIndex
        setAccordionActiveIndex(newState);
    };


    return (
      <div style={{display: 'flex', flexDirection: 'column'}} key={key}>
      <ResponsiveContainer height={100} disableFixed currentPage="maps">
        <Sidebar.Pushable>
          <Sidebar.Pusher>

          <SideControls collapsed={!controlsVisible} toggleCollapsed={() => setControlsVisible(!controlsVisible)}>
            <Row>
             <Cell large={12}><h5><strong>Explore</strong></h5></Cell>
            </Row>
            <InvisibleAccordion>
              {MapPageConfig.map((sectionConfig, idxkey) => {
                return (
                  <AccordionSection
                    title={sectionConfig.sectionText}
                    activeAccordion={accordionActiveIndex.level1}
                    handleAccordionClick={handleAccordionClick}
                    key={idxkey}
                  >
                    <MapLayerConfigSection
                      setMapOptions={setMapOptions}
                      layers={mapOptions[sectionConfig.section]}
                      sectionConfig={sectionConfig}
                    />
                  </AccordionSection>
                )
              })}





            </InvisibleAccordion>
          </SideControls>
          <MapContainer>
            <Map
                  // timeDimensionShapefileConfig={mapOptions.impactForecastInundation.extentLayerIsShowing ? ExtentForecast : {}}
                  // timeDimensionRasterConfig={mapOptions.impactForecastInundation.glofasLayerIsShowing ? GloFasForecast : {}}
              >
                {mapOptions.background.openStreetMapLayerIsShowing && <MapOpenStreetMap />}
                {shapeFilesShowing.map(config => <MapShapefile Map={Map} layerConfig={config} key={config.id} />)}               
                {rasterFilesShowing.map(rasterConfig => <MapRasters Map={Map} layerConfig={rasterConfig} key={rasterConfig.id} />)}
                {topographyLayersShowing.map(topographyConfig => <MapTopography Map={Map} layerConfig={topographyConfig} key={topographyConfig.name} />)}
              </Map>
          </MapContainer>

          <RightSideControl shapeFiles={shapeFilesShowing}
                            tiffFiles={[...rasterFilesShowing, ...topographyLayersShowing]}/>
          </Sidebar.Pusher>
          </Sidebar.Pushable>
        </ResponsiveContainer>
      </div>
    )
};

export default DataExplorer;